import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import bytype from './modules/bytype'


Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        bytype
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js